module.exports = __webpack_public_path__ + "img/pro_beijia_03_r.a1e51bda.png";